"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
require("./Autocomplete.css");
var UIProps_1 = require("../UIProps");
var useOnClickOutside_1 = require("../../hooks/useOnClickOutside");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var AutocompleteComp = function (props) {
    var el = react_1.useRef(null);
    var _a = __read(react_1.useState(-1), 2), activeSuggestion = _a[0], setActiveSuggestion = _a[1];
    var _b = __read(react_1.useState([]), 2), filteredSuggestions = _b[0], setFilteredSuggestions = _b[1];
    var _c = __read(react_1.useState(false), 2), showSuggestions = _c[0], setShowSuggestions = _c[1];
    var _d = __read(react_1.useState(''), 2), userInput = _d[0], setUserInput = _d[1];
    react_1.useEffect(function () {
        if (!props.selectedInputValue) {
            reset();
            setUserInput('');
        }
        else {
            updateSuggestions(props.selectedInputValue);
        }
    }, [props.selectedInputValue]);
    function reset() {
        setActiveSuggestion(-1);
        setShowSuggestions(false);
        setFilteredSuggestions([]);
    }
    function updateSuggestions(input) {
        var suggestions = props.suggestions;
        if (input && input.length > 0) {
            // Filter our suggestions that don't contain the user's input
            var filteredSuggestionList = suggestions.filter(function (suggestion) {
                // suggestion.label.toLowerCase().indexOf(input.toLowerCase()) > -1
                for (var term in suggestion.searchTerms)
                    if (suggestion.searchTerms[term]
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) > -1)
                        return true;
                return false;
            });
            if (props.sort) {
                filteredSuggestionList = lodash_1.orderBy(filteredSuggestionList, ['label'], [props.sort]);
            }
            // Update the user input and filtered suggestions, reset the active
            // suggestion and make sure the suggestions are shown
            setActiveSuggestion(0);
            setFilteredSuggestions(filteredSuggestionList);
            setUserInput(input);
        }
        else {
            setUserInput(input);
            reset();
        }
    }
    function onChange(e) {
        updateSuggestions(e.currentTarget.value);
        setShowSuggestions(true);
        if (props.onChange)
            props.onChange(e);
    }
    function onSubmit(index) {
        // Update the user input and reset the rest of the state
        reset();
        setUserInput(filteredSuggestions[index].label);
        props.onSuggestionSubmit(filteredSuggestions[index]);
    }
    // Event fired when the user presses a key down
    function onKeyDown(e) {
        var currentActiveSuggestion = activeSuggestion;
        var currentFilteredSuggestion = filteredSuggestions;
        if (currentActiveSuggestion > -1) {
            // User pressed the enter key,
            // update the input and close the suggestions
            if (e.keyCode === 13) {
                onSubmit(currentActiveSuggestion);
                setActiveSuggestion(-1);
                setShowSuggestions(false);
            }
            // User pressed the up arrow, decrement the index
            else if (e.keyCode === 38) {
                if (currentActiveSuggestion > 0) {
                    setActiveSuggestion(currentActiveSuggestion - 1);
                }
            }
            // User pressed the down arrow, increment the index
            else if (e.keyCode === 40) {
                if (currentActiveSuggestion > -1 &&
                    currentActiveSuggestion < currentFilteredSuggestion.length - 1) {
                    setActiveSuggestion(currentActiveSuggestion + 1);
                }
            }
        }
    }
    function onFocus(e) {
        var val = e.currentTarget.value;
        if (val && val.length > 0) {
            updateSuggestions(val);
            setShowSuggestions(true);
        }
    }
    useOnClickOutside_1.useOnClickOutside(el, function (e) {
        reset();
    });
    return (React.createElement("div", __assign({ ref: el }, UIProps_1.setUIProps(props), { className: 'autocompleteWrapper' }),
        React.createElement("div", { className: 'Autocomplete' },
            React.createElement("input", { type: "text", placeholder: props.inputPlaceHolder, autoFocus: props.inputAutoFocus || false, className: 'Autocomplete_search', onChange: onChange, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: function () { return setShowSuggestions(false); }, value: userInput })),
        showSuggestions && userInput ? (React.createElement("div", { className: "Autocomplete_suggestion" }, filteredSuggestions.length > 0 ? (filteredSuggestions.map(function (suggestion, index) {
            return (React.createElement("div", { className: classnames_1.default('Autocomplete_suggestionElement', {
                    'AutoComplete_suggestionElement-active': index === activeSuggestion,
                }), key: index, onMouseDown: function (e) {
                    onSubmit(index);
                } }, suggestion.label));
        })) : (React.createElement("p", { className: "Autocomplete_noSuggestions" },
            React.createElement("em", null, props.noMatchMessage || 'not found'))))) : (React.createElement(React.Fragment, null))));
};
exports.Autocomplete = React.memo(AutocompleteComp);
